import {
  ADD_BATCH,
  EDIT_BATCH,
  LIST_BATCH,
  LIST_TRACK_BATCH,
  VIEW_BATCH,
  DELETE_BATCH,
  // participants
  ADD_PARTICIPANTS,
  EDIT_PARTICIPANTS,
  LIST_PARTICIPANTS,
  LIST_PARTICIPANTSTATUS,
  VIEW_PARTICIPANTS,
  DELETE_PARTICIPANTS,
  BATCH_SUCCESS,
  BATCH_ERROR,
  SEND_INVITATION_MAIL,
  LIST_PARTICIPANTS_TRACK_BATCH,

} from "./actionTypes"

// add batch
export const addBatch = (data, history, callback) => {
  return {
    type: ADD_BATCH,
    payload: { data, history, callback }
  }
}

// edit batch
export const editBatch = (data, id, callback) => {
  return {
    type: EDIT_BATCH,
    payload: { data, id, callback },
  }
}

// list batch
export const listBatch = (data, callback) => {
  return {
    type: LIST_BATCH,
    payload: { data, callback },
  }
}

// list batch track
export const listBatchTrack = (id, callback) => {
  return {
    type: LIST_TRACK_BATCH,
    payload: { id, callback },
  }
}

// view batch
export const viewBatch = (data, history) => {
  return {
    type: VIEW_BATCH,
    payload: { data, history },
  }
}

// delete batch
export const deleteBatch = (data, callback) => {
  return {
    type: DELETE_BATCH,
    payload: { data, callback },
  }
}

// text
// add Participants
export const addParticipants = (data, id, callback) => {
  return {
    type: ADD_PARTICIPANTS,
    payload: { data, id, callback }
  }
}

// edit Participants
export const editParticipants = (data, id, callback) => {
  return {
    type: EDIT_PARTICIPANTS,
    payload: { data, id, callback },
  }
}

// list Participants
export const listParticipants = (data, id, callback) => {
  return {
    type: LIST_PARTICIPANTS,
    payload: { data, id, callback },
  }
}

export const listParticipantStatus = (data, id, callback) => {
  return {
    type: LIST_PARTICIPANTSTATUS,
    payload: { data, id, callback },
  }
}


// list Participants
export const listParticipantsTrack = (batchId, participantId, callback) => {
  return {
    type: LIST_PARTICIPANTS_TRACK_BATCH,
    payload: { batchId, participantId, callback },
  }
}

// view Participants
export const viewParticipants = (data, history) => {
  return {
    type: VIEW_PARTICIPANTS,
    payload: { data, history },
  }
}

// delete Participants
export const deleteParticipants = (data, callback) => {
  return {
    type: DELETE_PARTICIPANTS,
    payload: { data, callback },
  }
}

// send invitation
export const sendInvitationMail = (data, callback) => {
  return {
    type: SEND_INVITATION_MAIL,
    payload: { data, callback },
  }
}

export const batchSuccess = message => {
  return {
    type: BATCH_SUCCESS,
    payload: message,
  }
}

export const batchError = message => {
  return {
    type: BATCH_ERROR,
    payload: message,
  }
}
